<div class="position-relative">
  <input
    class="input-base"
    [class]="{
      'input-large': inputSize() === InputSize.large,
      'input-small': inputSize() === InputSize.small,
    }"
    [class.input-error]="error()"
    [attr.id]="controlId()"
    [value]="value()"
    [disabled]="disabled()"
    [placeholder]="placeholder()"
    [attr.inputMode]="'text'"
    autocomplete="postal-code"
    [maskito]="maskitoOptions()"
    (input)="handleInput($event)" />
</div>

